import AppLogo from '@/assets/logo/for-parents.svg?react';
import LoadingCircle from '@/components/ui/loading/Loading';

import CSSModule from './LoadingScreen.module.scss';

const LoadingScreen: React.FC = () => (
  <div className={CSSModule.LoadingScreen} data-testid="loading-screen">
    <span className={CSSModule.LoadingScreen__Inner}>
      <AppLogo className={CSSModule.LoadingScreen__Logo} />
      <LoadingCircle
        className={CSSModule.LoadingScreen__CircleContainer}
        svgClassName={CSSModule.LoadingScreen__Circle}
      />
    </span>
  </div>
);

export default LoadingScreen;
